import React, {
  HTMLAttributeAnchorTarget,
  HTMLAttributes,
  ReactNode,
  useMemo,
} from 'react';

import { getHostName, hasHostname } from 'helpers/url';

type CustomLinkProps = HTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode;
  className?: string;
  href: string | URL;
  target?: HTMLAttributeAnchorTarget;
};

const CustomLink = (props: CustomLinkProps) => {
  const { href, children, className, ...restProps } = props;
  const hostName = useMemo(() => getHostName(), []);
  const hrefStringify = href.toString();
  let redirectTo;

  if (hasHostname(hrefStringify)) {
    redirectTo = href;
  } else {
    redirectTo = `${hostName}${
      hrefStringify.startsWith('/') ? `${hrefStringify}` : `/${hrefStringify}`
    }`;
  }

  return (
    // eslint-disable-next-line test-selectors/anchor, react/jsx-props-no-spreading
    (<a
      href={redirectTo}
      className={className}
      {...restProps}
      data-palette="CustomLink">
      {children}
    </a>)
  );
};

export default CustomLink;
